import {ExpressionPath} from '@packages/systems/wfdl';
import {TEMP_PATH} from '@packages/utilities/expression-path-constants';

export const ANIMATION_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'animation'},
];

export const EASING_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'easing'},
];

export const DURATION_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'duration'},
];

export const INFINITE_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'infinite'},
];

export const DISABLE_SWIPE_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'disableSwipe'},
];

export const AUTOPLAY_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'autoplay'},
];

export const DELAY_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'delay'},
];

export const AUTO_MAX_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'autoMax'},
];

export const HIDE_ARROWS_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'hideArrows'},
];

export const NAV_ROUND_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'navRound'},
];

export const NAV_NUMBERS_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'navNumbers'},
];

export const NAV_SHADOW_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'navShadow'},
];

export const NAV_INVERT_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'navInvert'},
];

export const NAV_SPACING_PATH: ExpressionPath = [
  {in: 'Record', at: 'slider'},
  {in: 'Record', at: 'navSpacing'},
];

export const HAS_MOUNTED_PATH: ExpressionPath = [
  ...TEMP_PATH,
  {in: 'Record', at: 'hasMounted'},
];

export const SLIDES_PATH: ExpressionPath = [
  {in: 'Record', at: 'children'},
  {in: 'List', index: 0},
  {in: 'Element'}, // SliderMask
  {in: 'Record', at: 'children'},
];
